/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// v1_858: DOES ALEX'S LAST MESSAGE WAIT FOR THE CLIENT, OR FOR THE REVIEW?
// The client portal speaks again when the review finishes (the board lands)
// only if Alex's last message is not an unanswered question. It read "a
// question mark anywhere in the last 240 characters", so a holding message
// that offered a question and then closed with a promise to come back ("is
// there anything you'd like to ask me? Otherwise I'll ... come straight back to
// you the moment it's ready") read as a question: Alex had told the client to
// wait, the client waited, the portal waited for the client, and Alex never
// came back (walk w4f1b992e, 28/09/26, the 12:53 message). The decision now
// reads the last sentence alone, and a closing promise to come back counts as
// waiting for the review.

// The last sentence of a message (trailing quotes, brackets and whitespace kept
// with it).
export function lastSentence(text) {
  const t = String(text || '').trim();
  if (!t) return '';
  const parts = t.split(/(?<=[.!?…])["'”’)\]]*\s+/).map(s => s.trim()).filter(Boolean);
  return parts.length ? parts[parts.length - 1] : t;
}

// A closing promise to come back once the work is done.
const COME_BACK = /\b(?:come|get|be|circle|report)\s+(?:straight\s+|right\s+)?back\s+(?:to\s+you|with\s+you|in\s+touch)|\bpick\s+(?:this|it|things)\s+(?:back\s+)?up\s+with\s+you\b|\bthe\s+moment\s+(?:it|the\s+\w+)(?:'s|’s|\s+is)\s+(?:ready|done|finished|complete)|\bas\s+soon\s+as\s+(?:it|the\s+\w+)(?:'s|’s|\s+is)\s+(?:ready|done|finished|complete)|\bonce\s+(?:it|the\s+\w+)(?:'s|’s|\s+is|\s+has)\s+(?:ready|done|finished|complete|finished\s+running)/i;
export function promisesToComeBack(sentence) {
  return COME_BACK.test(String(sentence || ''));
}

// True when the message ends on a question the client is expected to answer.
export function awaitsClientAnswer(text) {
  const last = lastSentence(text);
  if (!last) return false;
  if (promisesToComeBack(last)) return false;
  return /\?["'”’)\]]*$/.test(last);
}

export default awaitsClientAnswer;
